import Marquee from "react-fast-marquee";

const WORDS = ["Autonomous Agents", "RAG Systems", "LLM Engineering", "AI Strategy", "MLOps", "Multi-Agent Orchestration", "GenAI Products"];

export default function EditorialMarquee() {
  return (
    <section className="relative z-[2] border-y border-white/10 bg-[#050505] py-10 overflow-hidden" data-testid="marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span
              className="font-display font-900 tracking-tighter text-6xl sm:text-7xl lg:text-8xl mx-8 text-transparent select-none"
              style={{ WebkitTextStroke: "1px rgba(255,255,255,0.18)" }}
            >
              {w}
            </span>
            <span className="h-3 w-3 rounded-full bg-[#8b7cff]/70 mx-2" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
